import { styled } from '@linaria/react';
import { cssTheme } from '../../../themes';
export const HEADER_HEIGHT = 65;
export const Header = /*#__PURE__*/styled('div')({
  name: "Header",
  class: "h1snn39y",
  propsAsIs: false
});
const _exp5 = /*#__PURE__*/() => ({
  showCloseButton
}) => showCloseButton ? cssTheme.layout.spacing.s900 : cssTheme.layout.spacing.s500;
export const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "h9a5vrv",
  propsAsIs: false,
  vars: {
    "h9a5vrv-0": [_exp5()]
  }
});
export const HeaderContent = /*#__PURE__*/styled('div')({
  name: "HeaderContent",
  class: "hq0smyo",
  propsAsIs: false
});
export const OverlayBody = /*#__PURE__*/styled('div')({
  name: "OverlayBody",
  class: "o1ucgd6k",
  propsAsIs: false
});
export const OverlayContent = /*#__PURE__*/styled('div')({
  name: "OverlayContent",
  class: "o1t3n39d",
  propsAsIs: false
});
export const OverlayFooter = /*#__PURE__*/styled('div')({
  name: "OverlayFooter",
  class: "ombvbq1",
  propsAsIs: false
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");